import { requestService as api } from "../Request.service"  
const API_URL = { 
  API_MANAGE: `/ERP/jo/manage.php`, 
  API_SEARCH: `/ERP/jo/search.php`, 
  API_APPROVE: `/ERP/jo/approve.php`,

  API_GETCODE: `/ERP/jo/get-jocode.php`, 
  API_CHECKCODE: `/ERP/jo/check-jocode.php`,
  API_SHIPPED: `/ERP/jo/shipped.php`,
  API_LABEL_ORDER: `/ERP/jo/label-order.php`,
  API_CANCEL: `/ERP/jo/cancel.php`,
};
  
const JobOrderService = () => { 
  
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);

  const code = () => api.get(`${API_URL.API_GETCODE}`);

  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});
  const checkjocode = (code) => api.post(`${API_URL.API_CHECKCODE}?code=${code}`);

  const approve = (parm = {}) => api.post(`${API_URL.API_APPROVE}`, parm);

  /* จำนวนที่ส่งแล้วรายรายการ — แยกจาก manage.php เพราะไม่ต้องออกเวอร์ชันใหม่ */
  const shippedGet = (jocode) => api.get(`${API_URL.API_SHIPPED}?jocode=${jocode}`);
  const shippedSave = (parm = {}) => api.put(`${API_URL.API_SHIPPED}`, parm);

  /* ใบสั่งงานปิดฉลาก — code คือ er_jo_ver_detail.code ของรายการสินค้าที่เลือก */
  const labelOrderGet = (code) => api.get(`${API_URL.API_LABEL_ORDER}?code=${code}`);

  /* ยกเลิกใบสั่งงาน — ตรวจก่อนว่าถูกดึงไปใช้ที่อื่นหรือยัง */
  const cancelCheck = (jocode) =>
    api.get(`${API_URL.API_CANCEL}?jocode=${jocode}`, { ignoreLoading: true });
  const cancelJo = (jocode, reason) =>
    api.post(`${API_URL.API_CANCEL}`, { jocode, reason });
  const uncancelJo = (jocode) => api.put(`${API_URL.API_CANCEL}`, { jocode });
  

  return {
    create,
    update,
    deleted,
    get, 

    code,

    search,
    checkjocode,
    approve,
    shippedGet,
    shippedSave,
    labelOrderGet,
    cancelCheck,
    cancelJo,
    uncancelJo,
};
};

export default JobOrderService;